// extracted by mini-css-extract-plugin
module.exports = {"map":"styles_map__81dDl"};